import InputSearch from 'core/modules/atoms/InputSearch';
import { Dialog } from 'ui';
import HeaderTabs from 'core/modules/components/tabs/HeaderTabs';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TreeViewSelected from './TreeViewSelected';
import TreeViewToSelect from './TreeViewToSelect';

function TreeView({ data, getData, onClose, onSelected, open, optionDisabled, titleDialog, titleName, value, tabToOpen }) {
  const [search, setSearch] = useState('');
  const [dataTree, setDataTree] = useState([]);
  const [selected, setSelected] = useState(value);
  const [tabActive, setTabActive] = useState(tabToOpen);
  const { t } = useTranslation(['general', 'actions']);

  const tabs = [
    { id: 'everything', name: t('general:everything') },
    { id: 'selected', name: `${t('general:selected')} (${selected.length})` },
  ];

  useEffect(() => {
    setSelected(value);
  }, [value]);

  function getDataTree() {
    const tree = data.map((item) => {
      const find = optionDisabled.find((element) => element.guid === item.guid);
      return { ...item, name: item[titleName], isDisabled: !!find };
    });

    setDataTree(tree);
  }

  function onChangeTab(tab) {
    setTabActive(tab);
  }

  function onChangeSelected(event) {
    setSelected(event);
  }

  function onChangeSearch(text) {
    getData({ search: text });
    setSearch(text);
  }

  function onCancel() {
    setSelected(value);
    closeModal();
  }

  function onSuccess() {
    onSelected(selected);
    closeModal();
  }

  function closeModal() {
    onClose(false);

    if (search) onChangeSearch('');
  }

  useEffect(getDataTree, [data]);

  useEffect(() => {
    setTabActive(tabToOpen);
  }, [tabToOpen]);

  return (
    <Dialog
      buttonTextCancel={t('actions:Cancel')}
      buttonTextSuccess={t('actions:Save')}
      className="tree-view"
      onCancel={onCancel}
      onClose={onCancel}
      onSuccess={onSuccess}
      isOpen={open}
      size="xl"
      title={titleDialog}
    >
      <div className="tree-view__search">
        <InputSearch onChange={onChangeSearch} placeholder={t('actions:Search')} value={search} iconLeft />
      </div>

      <HeaderTabs tabs={tabs} onChangeTab={onChangeTab} tabActive={tabToOpen} align="left" />
      {tabActive === 'everything' && <TreeViewToSelect data={dataTree} onChange={onChangeSelected} selected={selected} search={search} />}
      {tabActive === 'selected' && <TreeViewSelected selected={selected} setSelected={setSelected} />}
    </Dialog>
  );
}

TreeView.propTypes = {
  data: PropTypes.array.isRequired,
  getData: PropTypes.func,
  onClose: PropTypes.func,
  onSelected: PropTypes.func,
  open: PropTypes.bool,
  optionDisabled: PropTypes.array,
  titleDialog: PropTypes.string,
  titleName: PropTypes.string.isRequired,
  value: PropTypes.array,
  tabToOpen: PropTypes.oneOf(['everything', 'selected']),
};

TreeView.defaultProps = {
  getData: (e) => e,
  onClose: (e) => e,
  onSelected: (e) => e,
  open: false,
  optionDisabled: [],
  titleDialog: '',
  value: [],
  tabToOpen: 'everything',
};

export default TreeView;
